import React from "react";
import { Box } from "@mui/material";
import classNames from "classnames";

import Typography from "../Typography";
import { BoxPanelProps } from "./BoxPanel.types";
import { useStyles } from "./BoxPanel.styles";

function BoxPanel(props: BoxPanelProps) {
  const {
    actions,
    contentWithPadding,
    children,
    title,
    footer,
    variant,
    actionsPosition,
    footerAvailableHeight,
    hideHeader,
    headerNoBorder,
    fullHeight = true,
    ...other
  } = props;

  const classes = useStyles(props);

  const rootClassName = classNames(classes.root, {
    [classes.footerBorder]: !variant || variant === "footerBorder",
    [classes.footerBackground]: variant === "footerBackground",
    [classes.actionsBottom]: actionsPosition === "bottom",
  });

  const headerClassName = classNames(classes.header, {
    [classes.headerNoBorder]: headerNoBorder,
  });

  const contentClassName = classNames(classes.content, {
    [classes.contentWithPadding]: contentWithPadding,
  });

  return (
    <Box
      className={rootClassName}
      height={fullHeight ? "100%" : undefined}
      component="section"
      {...other}
    >
      {!hideHeader && (
        <div className={headerClassName}>
          <div className={classes.title}>
            <Typography
              variant="h3"
              fontWeight="semiBold"
              m={0}
              color="grey"
              tone={900}
            >
              {title}
            </Typography>
          </div>
          {actions && <div className={classes.actions}>{actions}</div>}
        </div>
      )}
      <div className={contentClassName}>{children}</div>
      {footer && <div className={classes.footer}>{footer}</div>}
    </Box>
  );
}

export default BoxPanel;
